import { initialPagination } from '@app/constants/pagination';

const tableDataInit = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    inspectors: [],
    waterbodies: [],
    categories: [],
    organizationalEntities: [],
  },
  loading: false,
  error: false,
};

const summaryDataInit = {
  loading: true,
  error: false,
  data: {
    observations: 0,
    waterbodies: 0,
    categories: [],
  },
};

export { summaryDataInit, tableDataInit };
